import React from 'react';

const OrderSummaryCheckout = () => {
    const orderDate = '2023-01-01';
    const invoiceNumber = 'INV-0750';
    const houseNumber = 'F1'; // Updated to house number
    const customerName = 'Kalidass';
    const totalAmount = 500.00;
    const paymentStatus = 'OverDue';
    const amountDue = 500.00;

    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="max-w-lg bg-white rounded-lg shadow-lg p-8">
                <h1 className="text-3xl font-semibold mb-6 text-center">Order Summary and Checkout</h1>
                <div className="border p-4 mb-4">
                    <h2 className="text-xl font-semibold mb-2">Order Details</h2>
                    <p className='mt-4'><strong>Order Date:</strong> {orderDate}</p>
                    <p className='mt-4'><strong>Invoice Number:</strong> {invoiceNumber}</p>
                    <p className='mt-4'><strong>House Number:</strong> {houseNumber}</p>
                    <p className='mt-4'><strong>Customer Name:</strong> {customerName}</p>
                    <p className='mt-4'><strong>Total Amount:</strong> ₹{totalAmount.toFixed(2)}</p>
                    <p className='mt-4'><strong>Payment Status:</strong> {paymentStatus}</p>
                    <p className='mt-4'><strong>Amount Due:</strong> ₹{amountDue.toFixed(2)}</p>
                    <button className="bg-blue-500 text-white rounded py-2 px-4 mt-4 hover:bg-blue-600 w-full">
                        Pay Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderSummaryCheckout;
